<template>
  <div class="demand_box">
    <div class="owner_title">修改金主需求</div>
    <div class="owner_box">
      <el-form
        ref="editInfoForm"
        :rules="rules"
        :model="editInfoForm"
        label-width="130px"
      >
        <el-form-item label="金主昵称">
          <div class="username">{{ user_name }}</div>
        </el-form-item>
        <el-form-item label="书名" prop="name">
          <el-input class="inpt_size" v-model="editInfoForm.name"></el-input>
        </el-form-item>
        <el-form-item label="金主给千字价格" prop="actual_cost">
          <el-input
            class="inpt_size"
            v-model="editInfoForm.actual_cost"
          ></el-input>
        </el-form-item>
        <el-form-item label="给写手千字价格" prop="writer_cost">
          <el-input
            class="inpt_size"
            v-model="editInfoForm.writer_cost"
          ></el-input>
        </el-form-item>
        <el-form-item label="每章字数" prop="each_chapter_num">
          <el-input
            class="inpt_size"
            v-model="editInfoForm.each_chapter_num"
          ></el-input>
        </el-form-item>
        <el-form-item label="任务要求" prop="ask">
          <el-input
            type="textarea"
            class="inpt_size textarea_ask"
            v-model="editInfoForm.ask"
          ></el-input>
        </el-form-item>
        <el-form-item label="上传需求文件">
          <el-upload
            class="upload-demo"
            :action="uploadUrl"
            multiple
            :before-remove="beforeRemove"
            :on-exceed="handleExceed"
            :on-change="fileChange"
            :on-success="fileSuccess"
            :file-list="file_list"
          >
            <el-button size="small" type="text" class="task_upload_btn">
              <i class="upload_icon iconfont icon-shangchuan"></i
              >点击上传</el-button
            >
          </el-upload>
        </el-form-item>
        <el-form-item>
          <div class="task_edit_btn">
            <el-button
              class="info_btn"
              type="primary"
              round
              @click="onSubmiOwnerDwmand"
              >确认修改</el-button
            >
            <el-button class="info_btn" type="info" plain round @click="goBack"
              >取消</el-button
            >
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import { edit_demand } from "@/utils/owner";
export default {
  data() {
    return {
      uploadUrl: this.$global.fileUploadUrl,
      user_name: "", //用户名称
      editdata: "", //参数对象
      editInfoForm: {
        departmentuser_id: "", //所属金主部id
        name: "", //文章名称
        actual_cost: "", //实际每千字/费用
        writer_cost: "", //写手每千字/费用
        each_chapter_num: "", //每章字数
        ask: "", //任务要求
        file: "", //需求文件
        connectionessay_id: "" //文章id
      },
      rules: {
        name: { required: true, trigger: "blur", message: "文章名称不能为空" },
        actual_cost: [
          {
            required: true,
            trigger: "blur",
            message: "金主给千字价格不能为空"
          },
          { pattern: /^[0-9]*$/, trigger: "blur", message: "价格只能为数字" }
        ],
        writer_cost: [
          {
            required: true,
            trigger: "blur",
            message: "给写手千字价格不能为空"
          },
          { pattern: /^[0-9]*$/, trigger: "blur", message: "价格只能为数字" }
        ],

        each_chapter_num: [
          {
            required: true,
            trigger: "blur",
            message: "每章字数不能为空"
          },
          { pattern: /^[0-9]*$/, trigger: "blur", message: "字数格式不正确" }
        ],
        ask: { required: true, trigger: "blur", message: "任务要求不能为空" }
      },
      file_list: [], //上传文件路径
      isFile: false, //是否上传文件
      filterData: "", //筛选数据
      fileListTask: [] //已上传文件列表
    };
  },
  created() {
    this.editdata = JSON.parse(decodeURIComponent(this.$route.query.data));
    console.log(" editdata", this.editdata);

    this.filterData = JSON.parse(this.$route.query.filter);
    this.user_name = this.editdata.operator_nickname;
    this.ownerId = JSON.parse(localStorage.getItem("userInfo")).id;
    this.getData();
  },

  methods: {
    // 获取数据
    getData() {
      var that = this;
      that.editInfoForm.departmentuser_id = this.ownerId;
      that.editInfoForm.connectionessay_id = this.editdata.id;
      that.editInfoForm.name = this.editdata.name;
      that.editInfoForm.actual_cost = this.editdata.actual_cost;
      that.editInfoForm.writer_cost = this.editdata.writer_cost;
      that.editInfoForm.each_chapter_num = this.editdata.each_chapter_num;
      that.editInfoForm.ask = this.editdata.ask;

      this.file_list.push({
        name: this.editdata.filename,
        url: this.editdata.file
      });
    },

    // 表单提交
    onSubmiOwnerDwmand() {
      var that = this;
      that.editInfoForm.departmentuser_id = that.ownerId;
      if (that.isFile == true) {
        var file_url = that.file_list[0].url;
        that.editInfoForm.file = file_url;
        console.log(file_url);
      }

      let obj = {
        ...that.editInfoForm
      };
      //修改金主信息
      edit_demand(obj).then(res => {
        if (res.data.code == 1) {
          that.$message.success(res.data.msg);
          this.$route.params.filter = this.filterData;
          this.$router.push({ path: "/taskCenter" });
          // this.$router.back();
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 文件上传成功
    fileSuccess(file, fileList) {
      console.log("fileList", fileList);

      var that = this;
      that.isFile = true;
      that.file_list.push({
        name: fileList.name,
        url: fileList.response.data.url
      });
      that.file_list.shift();
    },
    //文件上传
    fileChange(file, fileList) {
      var that = this;
      // that.isFile = true;
      // console.log("文件上传", fileList);
      // that.file_list = fileList;
      // console.log("****", that.file_list);
    },
    //   取消返回首页
    goBack() {
      var that = this;
      // that.$router.push("/taskCenter");
      this.$route.params.filter = this.filterData;
      // this.$router.back();
      this.$route.params.edit_id = 1;
      this.$router.push({ path: "/taskCenter" });
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    }
  }
};
</script>
<style scoped>
.el-main {
  margin: 0px;
  padding: 0px;
  background: #f5f7fa;
}
.demand_box {
  background-color: #ffffff;
  height: 100%;
}
.owner_title {
  font-size: 17px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #304265;
  background: #ffffff;
  padding: 15px;
  border: 1px solid #e4e9f1;
}
.username {
  font-size: 17px;
  font-weight: 600;
}
.owner_box {
  padding: 45px 30px;
}
.owner_box .el-form-item__label {
  width: 135px !important;
}
.el-main {
  padding: 0;
}
.inpt_size {
  width: 200px;
}
.upload_size {
  width: 230px;
}
.upload_icon {
  font-size: 15px;
  margin-right: 5px;
}
.info_btn {
  width: 200px;
  height: 35px;
}
.task_upload_btn {
  background: #f4f8fc;
  width: 150px;
}
.task_edit_btn {
  display: flex;
  flex-direction: row;
}
.textarea_ask {
  width: 400px;
}
</style>



// WEBPACK FOOTER //
// src/view/owner/TaskEdit.vue